import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { logout } from '../../redux/actions/user';


const TIMEOUT_MILLISECONDS = 300000;

class IdleTimer extends Component {
    constructor(props){
        super(props);

        this.state = {
            timerOn: false,
            listening: false,
            lastUpdate: Date.now(),
        }

        this.turnOnTimer = this.turnOnTimer.bind(this);
        this.turnOffTimer = this.turnOffTimer.bind(this);
        this.startListening = this.startListening.bind(this);
        this.stopListening = this.stopListening.bind(this);
        this.handleIdle = this.handleIdle.bind(this);

        this.handleListeners = this.handleListeners.bind(this);
        
    }

    componentDidMount(){
        if(typeof this.props.user.id !== 'undefined'){
            this.turnOnTimer();
            this.startListening();
        }
    }

    componentWillUpdate(nextProps, nextState){
        // Make it so we only update when the user logs in/out
        if (nextProps.user.id !== this.props.user.id) {
            // Check if the user is logged in
            if (typeof nextProps.user.id !== 'undefined') {
    
            // Start the timer
            this.turnOnTimer();
            this.attachListeners();
            }
        }
    }

    componentWillUnmount(){
        /** At this point we want to turn off timers */
        clearTimeout(this.timer);

        this.stopListening();

    }

    /** Listener events */

    handleListeners(e) {
        // Set new lastUpdate value to current time
        let lastUpdate = Date.now();
    
        // Check if it's been 1 seconds since the last update
        if (lastUpdate - this.state.lastUpdate > 1000) {
          // If it's been 1 seconds, send another update.
          this.turnOnTimer();
    
          // Reset the lastUpdate time.
          this.setState((prevState, props) => {
            return { lastUpdate };
          }, () => {
            
          });
        }
    }

    startListening(){
        if(!this.state.listening){
            this.setState({
                listening: true
            }, () => {
                window.addEventListener('mousemove', this.handleListeners)
                window.addEventListener('keypress', this.handleListeners)
                window.addEventListener('touchstart', this.handleListeners)
            })
        }
    }

    stopListening() {
        
        // Clear the mouse and keyboard event listeners
        window.removeEventListener('mousemove', this.handleListeners);
        window.removeEventListener('keypress', this.handleListeners);
        window.removeEventListener('touchstart', this.handleListeners);
    }


    /** Timer events */

    handleIdle() {
        // Stop the timer
        this.turnOffTimer();
    
        // Detatch the listeners
        this.stopListening();
    
        // Logout user
        this.props.logout();
    }

    turnOnTimer() {
        // Clear timer if one is already running so we don't have
        // rogue functions being called
        clearTimeout(this.timer);
    
        // If the timer has not been started, start it
        this.setState((prevState, props) => {
          return {
            timerOn: true
          };
        }, () => {
          // Set the timer for logout.
          this.timer = setTimeout(this.handleIdle, TIMEOUT_MILLISECONDS);
    
        });
    }

    turnOffTimer(){
        this.setState({
            timerOn: false
        }, () => {
            clearTimeout(this.timerChecker);
        })
    }

    render(){
        return(
            <div className="idle-timer">
                {this.props.children}
            </div>
        )
    }
}



function mapStateToProps({ routing, user }) {
    return {
      user
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      logout
    }, dispatch);
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(IdleTimer);


// WEBPACK FOOTER //
// ./src/components/IdleTimer/IdleTimer.js